import { CommonPage, Content, PageTitle, ResponsiveGap } from "common/Grid"
import { SalesChart } from "./Sales-chart"
import { useEffect, useState } from "react";
import { useGetSiteIdOptionsMutation } from "store/action/options-store";
import { FeesChart } from "pages/Dashboard/Fees-chart";
import { DailyTransactionChart } from "pages/Dashboard/DailyTransaction-chart";

export const Page = () => {
  const [getSiteIdOptionsApi] = useGetSiteIdOptionsMutation();
  const [siteIdOptionProvider, setSiteIdOptionProvider] = useState([]);

  useEffect(() => {
    getSiteIdOptionsApi().then(response => {
      setSiteIdOptionProvider(response?.data?.data ?? []);
    });
  }, [getSiteIdOptionsApi]);

  return (
    <CommonPage>
      <Content>
        <ResponsiveGap right={false} top={false} left={false}>
          <PageTitle title="Sales" />
          <SalesChart siteIdOptionProvider={siteIdOptionProvider} />
        </ResponsiveGap>
        <ResponsiveGap right={false} top={false} left={false}>
          <PageTitle title="Admin Fee" />
          <FeesChart siteIdOptionProvider={siteIdOptionProvider} />
        </ResponsiveGap>
        <ResponsiveGap right={false} top={false} left={false}>
          <PageTitle title="Daily Transaction" />
          <DailyTransactionChart siteIdOptionProvider={siteIdOptionProvider} />
        </ResponsiveGap>
        {/* <ResponsiveGap right={false} left={false}>
          <PageTitle title="Sales" />
          <SalesChart />
        </ResponsiveGap> */}
      </Content>
    </CommonPage>
  )
}